import { makeStyles } from "tss-react/mui";

import { actionPrimary } from "./action.styles";

const useOperationPopupStyles = makeStyles()((theme) => ({
  body: {
    "& .MuiPaper-root": {
      backgroundColor: theme.design.color.surface.raised,
      color: theme.design.color.text.primary,
      display: "flex",
      flexDirection: "column",
      borderRadius: theme.design.radius.xl,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      gap: theme.design.space.sm,
      boxShadow: theme.design.shadow.md,
      [theme.breakpoints.down("sm")]: { width: "100%" },
    },
  },
  modalContent: { position: "relative" },
  contentBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.design.space.lg,
    padding: "32px 96px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: { padding: "32px 22px" },
  },
  closeIconBody: {
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    right: 25,
    top: 25,
    "&>button": {
      padding: 0,
      minWidth: "auto",
      "&>svg": {
        color: theme.design.color.text.secondary,
        cursor: "pointer",
        transition: `color ${theme.design.motion.duration.normal}`,
        width: theme.design.size.icon.lg,
        height: theme.design.size.icon.lg,
        "&:hover": { color: theme.design.color.text.primary },
      },
    },
  },
  logoImg: { width: theme.design.size.control.lg },
  titleText: { fontSize: theme.design.typography.size.title },

  depositContentBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.design.space.lg,
    padding: "32px 56px",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: { padding: "32px 22px" },
  },

  failedTitleText: {
    fontSize: theme.design.typography.size.title,
    textAlign: "center",
  },
  inventoryTitle: { color: theme.design.color.text.muted },

  inventoryBox: {
    minWidth: 400,
    backgroundColor: theme.design.color.surface.raised,
    height: 160,
    borderRadius: theme.design.radius.xl,
    display: "grid",
    gap: theme.design.space.sm,
    gridTemplateColumns: "repeat(auto-fill, minmax(66px, 1fr))",
    overflowY: "auto",
    padding: theme.design.space.lg,
    maxHeight: 300,

    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      width: "90%",
    },
  },

  confirmBut: {
    ...actionPrimary(theme),
    minWidth: 160,
    textDecoration: "none",
    marginTop: theme.design.space.lg,
  },

  details: {
    display: "flex",
    flexDirection: "column",
    gap: theme.design.space.md,
    marginTop: theme.design.space.xl,
    maxWidth: 240,
    textAlign: "center",
  },

  balanceDetails: {
    display: "flex",
    flexDirection: "column",
    gap: theme.design.space.md,
    marginTop: theme.design.space.xl,
    maxWidth: 240,
    textAlign: "center",
    color: theme.design.color.overlay.white20,
  },

  detailColumn: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    alignItems: "center",
    gap: theme.design.space.xl,

    "&>div": {
      display: "flex",
      gap: theme.design.space.sm,
      alignItems: "center",
    },

    "& img": { width: theme.design.size.icon.lg },
  },
  familyTaxBox: {
    padding: `${theme.design.space.sm}px ${theme.design.space.md}px`,
    borderRadius: theme.design.radius.md,
    backgroundColor: theme.design.color.overlay.white10,
    color: theme.design.color.status.info,
    fontSize: 13,
    textAlign: "center",
    lineHeight: 1.6,
    display: "flex",
    gap: theme.design.space.sm,
    alignItems: "center",
  },
  cashIcon: { width: theme.design.size.icon.lg },
}));

export default useOperationPopupStyles;
